import { MessageEventStream } from "../types/stream"

export default (endpoint: string): MessageEventStream => endpoint.startsWith("ws") ? new WebSocket(endpoint) : new EventSource(endpoint)
